import { th } from 'style/theme';

/**
 * Product color palettes for the Policy / Member Guide view.
 */

export const POLICY_COLOR_THEMES = {
  // Nomad Insurance
  picton: {
    main: 'blue', // header background + wave fill
    navBase: 'blue', // sidebar / dropdown link text
    navActive: 'orange' // active or hovered link
  },
  // Nomad Citizen
  fountain: {
    main: 'fountainBlue',
    navBase: 'fountainBlue',
    navActive: 'confetti'
  }
};

/**
 * styled-components helper. Resolves a palette role (e.g. 'main', 'navBase',
 * 'navActive') to a theme color based on the `$color` transient prop,
 * falling back to the 'picton' palette.
 *
 *   background-color: ${policyColor('main')};
 */

export const policyColor = (role) => (props) => {
  const palette = POLICY_COLOR_THEMES[props.$color] || POLICY_COLOR_THEMES.picton;

  return th(`colors.${palette[role]}`)(props);
};
